import React from "react";
import { MacOsStubContainer } from "shared/Slider/styled";

const MacOsStub = () => {
  return <MacOsStubContainer />;
};

export default MacOsStub;
